import {CategoryModel} from "./AvailableScopesHeader";

export class AccessToken {
    access_token: string;
    token_type: string;
}

export class LoginRequest{
    username: string;
    password: string;
}

export class LoginResponse {
  constructor(
    public accessToken: string,
    public categoryModels: CategoryModel[])
  { }
}
